export default __webpack_public_path__ + "img/glp_avatar-963301fc120816564d7b15dc9b4fa219.png";